<template>
  <div class="dangJianShe">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="ruleFormYan">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="培训类型" ref="peixun_lei" prop="peixun_lei">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.peixun_lei" multiple
                          placeholder="请选择" class="inp">
                <el-option
                  v-for="item in peixunTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.peixun_lei.indexOf(4) != -1">
          <el-form-item label="其他培训类型" ref="peixun_qita" prop="peixun_qita">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.peixun_qita" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <div v-for="(item,index) in ruleForm.ksList" :key="item.id">
          <el-col :span="24">
            <div class="title-flex">
              <b>课时</b>
              <img src="@/assets/images/tianjiaicon.png" v-if="index == 0" class="add" @click="addKs()" alt="">
              <img src="@/assets/images/jianhaoicon.png" v-else class="add" @click="delKs(index)" alt="">
              <div class="tips">
                <i class="iconfont icon-xinxitishi"></i>注：
                1课时为45分钟，如单价设置未按照45分钟/课时设置，需进行折算。
                折算公式：单价/实际课程时间（分钟）×45分钟
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程名称"
                          :ref="'ksList.' + index + '.name'"
                          :prop="'ksList.' + index + '.name'"
                          :rules="{
                              required: false, message: '请输入', trigger: 'blur'
                            }">
              <div class="flex justify-start align-center">
                <el-input v-model="item.name" class="inp"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课时单价"
                          :ref="'ksList.' + index + '.price'"
                          :prop="'ksList.' + index + '.price'"
                          :rules="{
                              required: false, message: '请输入', trigger: 'blur'
                            }">
              <div class="flex justify-start align-center">
                <el-input v-model="item.price" class="inp">
                  <template  slot="append">元/课时</template>
                </el-input>
              </div>
            </el-form-item>
          </el-col>
        </div>
        <div class="btn-box">
          <div class="btn pointer" @click="submitForm('ruleForm',1)">临时保存</div>
          <div class="btn pointer margin-left-xs" @click="submitForm('ruleForm',2)">提交</div>
        </div>
        <div v-for="(item,index) in ruleForm.jcList" :key="item.id">
          <el-col :span="24">
            <div class="title-flex">
              <b>教材</b>
              <img src="@/assets/images/tianjiaicon.png" v-if="index == 0" class="add" @click="add()" alt="">
              <img src="@/assets/images/jianhaoicon.png" v-else class="add" @click="del(index)" alt="">
            </div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教材名称"
                          :ref="'jcList.' + index + '.name'"
                          :prop="'jcList.' + index + '.name'"
                          :rules="{
                              required: false, message: '请输入', trigger: 'blur'
                            }">
              <div class="flex justify-start align-center">
                <el-input v-model="item.name" class="inp"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教材来源"
                          :ref="'jcList.' + index + '.laiyuan'"
                          :prop="'jcList.' + index + '.laiyuan'"
                          :rules="{
                              required: false, message: '请选择', trigger: 'change'
                            }">
              <div class="flex justify-start align-center">
                <el-select v-model="item.laiyuan" placeholder="请选择" class="inp">
                  <el-option
                    v-for="item in jiaocaiSource"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教材是否备案"
                          :ref="'jcList.' + index + '.isbeian'"
                          :prop="'jcList.' + index + '.isbeian'"
                          :rules="{
                              required: false, message: '请选择', trigger: 'change'
                            }">
              <div class="flex justify-start align-center">
                <el-select v-model="item.isbeian" placeholder="请选择" class="inp">
                  <el-option
                    v-for="item in isYes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教材是否评估"
                          :ref="'jcList.' + index + '.ispinggu'"
                          :prop="'jcList.' + index + '.ispinggu'"
                          :rules="{
                              required: false, message: '请选择', trigger: 'change'
                            }">
              <div class="flex justify-start align-center">
                <el-select v-model="item.ispinggu" placeholder="请选择" class="inp">
                  <el-option
                    v-for="item in isYes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="item.ispinggu == 1">
            <el-form-item label="评估结果"
                          :ref="'jcList.' + index + '.pinggu_isok'"
                          :prop="'jcList.' + index + '.pinggu_isok'"
                          :rules="{
                              required: false, message: '请选择', trigger: 'change'
                            }">
              <div class="flex justify-start align-center">
                <el-select v-model="item.pinggu_isok" placeholder="请选择" class="inp">
                  <el-option
                    v-for="item in isOk"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
        </div>
      </el-row>
    </el-form>
    <div class="btn-box">
      <div class="btn pointer" @click="submitJiaoCai(1)">临时保存</div>
      <div class="btn pointer margin-left-xs" @click="submitJiaoCai(2)">提交</div>
    </div>
  </div>
</template>
<script>
import {scrollIntoView} from "@/utils/utils";
import {isOk, isYes, jiaocaiSource, peixunTypeOptions} from "@/utils/const";
import {
  save_classes,
  get_yunying, save_jiaocai
} from "@/api/index";
export default {
  name: "kecheng",
  data() {
    return {
      isYes: isYes,
      isOk: isOk,
      jiaocaiSource: jiaocaiSource,
      peixunTypeOptions:peixunTypeOptions,
      ruleForm: {
        peixun_lei: [], // 培训类型
        peixun_qita:'', // 其他培训类型
        jcList: [{
          name: '',
          isbeian: '',
          ispinggu: '',
          pinggu_isok: '',
          laiyuan: '',
          id: Date.now()
        }],
        ksList:[{
          name: '',
          price: '',
          id: Date.now()+1
        }]
      },
      rules: {
        peixun_qita: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        peixun_lei: [
          {required: false, message: '请选择', trigger: 'change'}
        ]
      }
    }
  },
  components: {},
  created() {
    this.init()
  },
  methods: {
    async init(){
      let _data = await get_yunying(3);
      if(_data.status == 200){
        this.ruleForm = {
          peixun_lei: _data.data.peixun_lei ? _data.data.peixun_lei.split(',').map(Number) : [],  // 培训类型
          peixun_qita: _data.data.peixun_qita, // 其他培训类型
          jcList: _data.data.jcList.length ? _data.data.jcList : [{
            name: '',
            isbeian: '',
            ispinggu: '',
            pinggu_isok: '',
            laiyuan: '',
            id: Date.now()
          }],
          ksList: _data.data.ksList.length ? _data.data.ksList : [{
            name: '',
            price: '',
            id: Date.now()+1
          }]
        }
      }
    },

    submitForm(formName,zancun) {
      if(zancun == 1){
        this.submitInfo(zancun)
      }else {
        this.$refs[formName].validate((valid, validates) => {
          if (valid) {
            this.submitInfo(zancun)
          } else {
            scrollIntoView(this, validates)
          }
        });
      }
    },

    async submitInfo(zancun) {
      let _data = await save_classes(
        zancun,
        this.ruleForm.peixun_lei.join(','),
        this.ruleForm.peixun_qita,
        JSON.stringify(this.ruleForm.ksList)
      );
      if(_data.status == 200){
        this.$message.success(_data.msg)
      } else {
        this.$message.error(_data.msg)
      }
    },

    async submitJiaoCai(zancun) {
      let _data = await save_jiaocai(
        zancun,
        JSON.stringify(this.ruleForm.jcList),
      );
      if(_data.status == 200){
        this.$message.success(_data.msg)
      } else {
        this.$message.error(_data.msg)
      }
    },

    add() {
      this.ruleForm.jcList.push({
        name: '',
        isbeian: '',
        ispinggu: '',
        pinggu_isok: '',
        laiyuan: '',
        id: Date.now()
      })
    },
    del(index) {
      this.ruleForm.jcList.splice(index, 1)
    },
    addKs() {
      this.ruleForm.ksList.push({
        name: '',
        price: '',
        id: Date.now()
      })
    },
    delKs(index) {
      this.ruleForm.ksList.splice(index, 1)
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.dangJianShe {
  .width {
    width: 400px;
  }

  .title-flex {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 20px;

    b {
      font-size: 18px;
      color: #000000;
      font-weight: bold;
      margin-right: 10px;
    }
  }

  .add {
    width: 24px;
    cursor: pointer;
  }

  .inp {
    flex: 1;
  }

  .tips {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    background-color: #fef0ef;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 14px;
    color: #f34336;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 16px;

    i {
      font-size: 20px;
      color: #f34336;
      margin-right: 4px;
    }

    &.width {
      width: 160px;
    }
  }

  .look {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    border: 1px solid #2791ff;
    color: #2791ff;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    margin-left: 10px;
    border-radius: 4px;
  }

  .btnUp {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    margin-left: 10px;
    background-image: linear-gradient(90deg,
      #2791ff 0%,
      #81b6ff 100%);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #ffffff;

    i {
      font-size: 20px;
      color: #ffffff;
      margin-right: 5px;
      font-weight: 100;
    }
  }

  .btn-box {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 30px 0;

    .btn {
      width: 180px;
      height: 40px;
      background-image: linear-gradient(0deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      letter-spacing: 1px;
      color: #ffffff;
    }
  }
}
</style>


